// First: in demo mode it replaces this computer's storage with memory before anything else can read or write it.
import "./lib/demoGuard";
import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/fraunces";
import "@fontsource-variable/plus-jakarta-sans";
import "./styles.css";
import { App } from "./App";
import { initApp } from "./state";
import { installOffer, type InstallEvent } from "./lib/install";

// Chrome on Android offers the install once; it is kept so the sign-in screen can show an "Install" button.
addEventListener("beforeinstallprompt", (event) => { event.preventDefault(); installOffer.event = event as InstallEvent; dispatchEvent(new Event("mm-install-offer")); });
addEventListener("appinstalled", () => { installOffer.event = null; dispatchEvent(new Event("mm-install-offer")); });
void initApp();
createRoot(document.getElementById("root")!).render(<React.StrictMode><App /></React.StrictMode>);
